import styled from "styled-components"

export const Content = styled.div`
  height: var(--navbar-height);
  background-color: var(--navbar-background);
  display: flex;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  align-items: center;
  justify-content: space-between;
  color: #fff;
  backdrop-filter: blur(4px);
`
export const Right = styled.div`
  height: var(--navbar-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SearchBlock = styled.div`
  width: ${({ open }) => (open ? "100%" : "0px")};
  transition: all 0.3s ease-in-out;
  opacity: ${({ open }) => (open ? 1 : 0)};
`
